import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Cordova = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M5.01 2.667 2.685 5.943l.598 7.39H4v-1.228h3.333v1.228h1.334v-1.228H12v1.228h.718l.598-7.42-2.325-3.246H5.01Zm.323 12H2.052l-.736-9.1 3.006-4.234h7.354l3.008 4.201-.736 9.133h-3.281v-1.228H10v1.228H6v-1.228h-.667v1.228ZM6 7.333h1.333v2H6v-2Zm2.667 0H10v2H8.667v-2ZM10 6H6v-.667L4.667 6.667 5.333 10h5.334l.666-3.333L10 5.333V6ZM7.333 4v.667h1.334V4h2l2 2L12 11.333H4L3.333 6l2-2h2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Cordova;
